export class WeekRecord {

    constructor(
        public weekNum: number,
        public valueThisYear: number,
        public valueLastYear: number
    ){}
}
